import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-3f5dc08f"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "pedidos-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "pedidos-content" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Gestión de Pedidos", -1 /* HOISTED */));
const _hoisted_5 = { class: "table-container" };
const _hoisted_6 = {
    key: 0,
    class: "loading-overlay"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "spinner" }, null, -1 /* HOISTED */));
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = { class: "pedidos-table" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "ID Pedido"),
        /*#__PURE__*/ _createElementVNode("th", null, "Comprador"),
        /*#__PURE__*/ _createElementVNode("th", null, "Fecha"),
        /*#__PURE__*/ _createElementVNode("th", null, "Estado"),
        /*#__PURE__*/ _createElementVNode("th", null, "Total"),
        /*#__PURE__*/ _createElementVNode("th", { class: "actions-column" }, "Acciones")
    ])
], -1 /* HOISTED */));
const _hoisted_11 = { class: "precio" };
const _hoisted_12 = { class: "actions-column" };
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
    key: 2,
    class: "no-results-message"
};
const _hoisted_15 = { class: "modal-header" };
const _hoisted_16 = { class: "modal-title" };
const _hoisted_17 = { class: "modal-body" };
const _hoisted_18 = { class: "modal-info-grid" };
const _hoisted_19 = { class: "modal-info-item" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "info-label" }, "Comprador:", -1 /* HOISTED */));
const _hoisted_21 = { class: "info-value" };
const _hoisted_22 = { class: "modal-info-item" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "info-label" }, "Fecha:", -1 /* HOISTED */));
const _hoisted_24 = { class: "info-value" };
const _hoisted_25 = { class: "modal-info-item" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "info-label" }, "Estado:", -1 /* HOISTED */));
const _hoisted_27 = { class: "info-value precio" };
const _hoisted_28 = { class: "modal-info-item" };
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "info-label" }, "Total:", -1 /* HOISTED */));
const _hoisted_30 = { class: "info-value precio" };
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "modal-subtitle" }, "Productos:", -1 /* HOISTED */));
const _hoisted_32 = { class: "productos-lista" };
const _hoisted_33 = ["src"];
const _hoisted_34 = { class: "producto-detalles" };
const _hoisted_35 = { class: "producto-nombre" };
const _hoisted_36 = { class: "producto-infop" };
const _hoisted_37 = { class: "producto-infop" };
const _hoisted_38 = { class: "producto-infop" };
const _hoisted_39 = { class: "producto-infop" };
const _hoisted_40 = { key: 0 };
const _hoisted_41 = {
    key: 1,
    class: "producto-actions"
};
const _hoisted_42 = ["onClick"];
import { ref, onMounted } from "vue";
import Sidebar from "@/components/Sidebar.vue";
import Header from "@/components/HeaderDashboard.vue";
import Swal from "sweetalert2";
import { EyeIcon, XIcon, CheckCircleIcon } from 'lucide-vue-next';
import { PedidoService } from "@/services/PedidoService";
import { formatCurrency } from "@/utils/formatPrice";
import { config } from '@/config';
import { hasPermission } from '@/store/userStore';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const isLoading = ref(false);
        const esComprador = ref(false);
        const esVendedor = ref(true);
        const pedidos = ref([]);
        const pedidoSeleccionado = ref(null);
        const modalVisible = ref(false);
        const formatFecha = (fecha) => {
            const options = { year: "numeric", month: "long", day: "numeric" };
            return new Date(fecha).toLocaleDateString("es-ES", options);
        };
        onMounted(async () => {
            isLoading.value = true;
            try {
                const response = await PedidoService.getConfirmacionesVendedor();
                if (response.exito) {
                    pedidos.value = response.datos;
                }
            }
            catch (error) {
                Swal.fire("Error", "No se pudieron cargar las confirmaciones del vendedor", "error");
            }
            finally {
                isLoading.value = false;
            }
        });
        const getEstadoClase = (estado) => {
            switch (estado) {
                case "Confirmado":
                    return "estado-confirmado"; // verde
                case "En envío":
                    return "estado-envio"; // azul
                case "Pagado":
                    return "estado-pagado"; // morado
                case "Pendiente":
                default:
                    return "estado-pendiente"; // rojo o gris
            }
        };
        const abrirModalDetalles = (pedido) => {
            pedidoSeleccionado.value = pedido;
            modalVisible.value = true;
        };
        const cerrarModal = () => {
            modalVisible.value = false;
        };
        const confirmarStock = async (producto) => {
            try {
                // Paso 1: Preguntar al vendedor si es completo, parcial o no tiene
                const result = await Swal.fire({
                    title: "Confirmación de Stock",
                    text: `¿El stock de ${producto.nombreRepuesto} está completo, parcial o no disponible?`,
                    icon: "question",
                    showCancelButton: true,
                    showDenyButton: true,
                    confirmButtonText: "Completo",
                    cancelButtonText: "Parcial",
                    denyButtonText: "No tiene",
                });
                let nuevoEstado = "";
                let nuevaCantidad = producto.cantidadConfirmada ?? 0;
                if (result.isConfirmed) {
                    nuevoEstado = "Completo";
                    nuevaCantidad = producto.cantidadSolicitada;
                }
                else if (result.dismiss === Swal.DismissReason.cancel) {
                    // Stock parcial: solicitar cantidad
                    const { value: cantidad } = await Swal.fire({
                        title: "Cantidad disponible",
                        input: "number",
                        inputLabel: `Cantidad que puede proveer de ${producto.nombreRepuesto}`,
                        inputPlaceholder: "Ingrese la cantidad disponible",
                        showCancelButton: true,
                        inputValidator: (value) => {
                            if (!value || isNaN(Number(value)) || Number(value) <= 0) {
                                return "Por favor, ingrese una cantidad válida.";
                            }
                            if (Number(value) > producto.cantidadSolicitada) {
                                return `No puede superar la cantidad solicitada: ${producto.cantidadSolicitada}`;
                            }
                            return null;
                        },
                    });
                    if (!cantidad)
                        return; // Si canceló, salir
                    nuevoEstado = "Parcial";
                    nuevaCantidad = Number(cantidad);
                }
                else if (result.isDenied) {
                    nuevoEstado = "Sin stock";
                    nuevaCantidad = 0;
                }
                else {
                    return; // No eligió nada
                }
                // Paso 2: Confirmación final antes de enviar al backend
                const confirmacionFinal = await Swal.fire({
                    title: "¿Está seguro?",
                    text: `Va a establecer el stock de ${producto.nombreRepuesto} como: ${nuevoEstado} (${nuevaCantidad} unidades).`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sí, confirmar",
                    cancelButtonText: "Cancelar",
                });
                if (!confirmacionFinal.isConfirmed)
                    return;
                isLoading.value = true; // Desactivar loading
                // Llamada al backend para confirmar
                await PedidoService.confirmarProducto({
                    confirmacionId: producto.confirmacionVendedorID,
                    cantidadConfirmada: nuevaCantidad,
                });
                // **Actualizar lista de pedidos**
                const response = await PedidoService.getConfirmacionesVendedor();
                if (response.exito) {
                    pedidos.value = response.datos;
                    // **Actualizar el pedido seleccionado** con los detalles más recientes
                    if (pedidoSeleccionado.value) {
                        const actualizado = pedidos.value.find(p => p.pedidoId === pedidoSeleccionado.value.pedidoId);
                        if (actualizado) {
                            pedidoSeleccionado.value = actualizado;
                        }
                    }
                }
                Swal.fire("Confirmado", `Se actualizó el stock de ${producto.nombreRepuesto}.`, "success");
            }
            catch (error) {
                console.error(error);
                Swal.fire("Error", "No se pudo confirmar el stock del producto.", "error");
            }
            finally {
                isLoading.value = false; // Desactivar loading
            }
        };
        const getImagen = (imagen) => {
            if (!imagen)
                return require("@/assets/paquete.png");
            return imagen.startsWith('http') ? imagen : `${config.API_URL}/${imagen}`;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" Header "),
                _createVNode(Header),
                _createElementVNode("div", _hoisted_2, [
                    _createCommentVNode(" Sidebar "),
                    _createVNode(Sidebar),
                    _createCommentVNode(" Main Content "),
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createCommentVNode(" Tabla de pedidos con loading "),
                        _createElementVNode("div", _hoisted_5, [
                            _createCommentVNode(" Loading "),
                            (isLoading.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createCommentVNode(" Tabla "),
                                    _createElementVNode("table", _hoisted_9, [
                                        _hoisted_10,
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pedidos.value, (pedido) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: pedido.pedidoId
                                                }, [
                                                    _createElementVNode("td", null, "#" + _toDisplayString(pedido.codigoPedido), 1 /* TEXT */),
                                                    _createElementVNode("td", null, _toDisplayString(pedido.nombreVendedor), 1 /* TEXT */),
                                                    _createElementVNode("td", null, _toDisplayString(formatFecha(pedido.fechaCreacion)), 1 /* TEXT */),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass(['estado-badge', getEstadoClase(pedido.estado)])
                                                        }, _toDisplayString(pedido.estado), 3 /* TEXT, CLASS */)
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(formatCurrency)(pedido.total)), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_12, [
                                                        _createElementVNode("button", {
                                                            onClick: ($event) => (abrirModalDetalles(pedido)),
                                                            class: "btn btn-icon btn-details",
                                                            title: "Ver detalles"
                                                        }, [
                                                            _createVNode(_unref(EyeIcon), { size: 18 })
                                                        ], 8 /* PROPS */, _hoisted_13)
                                                    ])
                                                ]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ])
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                            _createCommentVNode(" No resultados "),
                            (!isLoading.value && pedidos.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, " No hay pedidos disponibles "))
                                : _createCommentVNode("v-if", true)
                        ])
                    ])
                ]),
                _createCommentVNode(" Modal Detalles Pedido "),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (modalVisible.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-overlay",
                                onClick: cerrarModal
                            }, [
                                _createElementVNode("div", {
                                    class: "modal-content",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("h2", _hoisted_16, "Detalles del Pedido #" + _toDisplayString(pedidoSeleccionado.value?.codigoPedido), 1 /* TEXT */),
                                        _createElementVNode("button", {
                                            onClick: cerrarModal,
                                            class: "btn-close",
                                            title: "Cerrar"
                                        }, [
                                            _createVNode(_unref(XIcon), { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("div", _hoisted_19, [
                                                _hoisted_20,
                                                _createElementVNode("span", _hoisted_21, _toDisplayString(pedidoSeleccionado.value?.nombreVendedor), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_22, [
                                                _hoisted_23,
                                                _createElementVNode("span", _hoisted_24, _toDisplayString(pedidoSeleccionado.value?.fechaCreacion ?
                                                    formatFecha(pedidoSeleccionado.value.fechaCreacion) : ''), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_25, [
                                                _hoisted_26,
                                                _createElementVNode("span", _hoisted_27, _toDisplayString(pedidoSeleccionado.value?.estado), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_28, [
                                                _hoisted_29,
                                                _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(formatCurrency)(pedidoSeleccionado.value?.total ?? 0)), 1 /* TEXT */)
                                            ])
                                        ]),
                                        _hoisted_31,
                                        _createElementVNode("ul", _hoisted_32, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pedidoSeleccionado.value?.detalles, (producto, index) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    key: index,
                                                    class: "producto-item d-flex align-items-start gap-3"
                                                }, [
                                                    _createCommentVNode(" Imagen del producto "),
                                                    (producto.imagenUrl)
                                                        ? (_openBlock(), _createElementBlock("img", {
                                                            key: 0,
                                                            src: getImagen(producto.imagenUrl),
                                                            alt: "Producto",
                                                            class: "producto-img-modal"
                                                        }, null, 8 /* PROPS */, _hoisted_33))
                                                        : _createCommentVNode("v-if", true),
                                                    _createCommentVNode(" Información del producto "),
                                                    _createElementVNode("div", _hoisted_34, [
                                                        _createElementVNode("span", _hoisted_35, [
                                                            _createTextVNode(_toDisplayString(producto.nombreRepuesto) + " ", 1 /* TEXT */),
                                                            _createElementVNode("span", {
                                                                class: _normalizeClass(["badge estado-badge", producto.confirmado ? 'estado-pagado' : 'estado-pendiente'])
                                                            }, _toDisplayString(producto.confirmado ? 'Confirmado' : 'Pendiente'), 3 /* TEXT, CLASS */)
                                                        ]),
                                                        _createElementVNode("span", _hoisted_36, "Cantidad: " + _toDisplayString(producto.cantidadSolicitada), 1 /* TEXT */),
                                                        _createElementVNode("span", _hoisted_37, "Cantidad Confirmada: " + _toDisplayString(producto.cantidadConfirmada), 1 /* TEXT */),
                                                        _createElementVNode("span", _hoisted_38, "Precio: " + _toDisplayString(_unref(formatCurrency)(producto.precioVenta)), 1 /* TEXT */),
                                                        _createElementVNode("span", _hoisted_39, "Total: " + _toDisplayString(_unref(formatCurrency)(producto.precioVenta *
                                                            producto.cantidadSolicitada)), 1 /* TEXT */),
                                                        (producto.confirmado)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_40, " (Confirmado: " + _toDisplayString(producto.cantidadConfirmada) + ", Total: " + _toDisplayString(_unref(formatCurrency)(producto.precioVenta *
                                                                producto.cantidadConfirmada)) + ") ", 1 /* TEXT */))
                                                            : _createCommentVNode("v-if", true)
                                                    ]),
                                                    _createCommentVNode(" Botón de confirmar stock "),
                                                    (!producto.confirmado && esVendedor.value && _unref(hasPermission)('ORD_MANAGE'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                            _createElementVNode("button", {
                                                                onClick: ($event) => (confirmarStock(producto)),
                                                                class: "btn btn-success d-flex align-items-center gap-2",
                                                                title: "Confirmar stock"
                                                            }, [
                                                                _createVNode(_unref(CheckCircleIcon), { size: 18 }),
                                                                _createTextVNode(" Confirmar Stock ")
                                                            ], 8 /* PROPS */, _hoisted_42)
                                                        ]))
                                                        : _createCommentVNode("v-if", true)
                                                ]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
